import { Skeleton } from "~/components/skeleton";

export default function DashboardBreadcrumsLoading() {
	return <Skeleton className="h-4 w-16 rounded-md"></Skeleton>;
}
